import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { openModal } from '../../../store/Modal/actions';
import { playTrack, pauseTrack, stopTrack, seekTrack } from '../../../store/AudioPlayer/actions';
import { formatSecondsToTime } from '../../../utilities/format';
import { cl } from '../../../utilities/cl';

import SvgPlayVideo from '../../SVG/PlayVideo';
import SvgPlay from '../../SVG/Play';
import SvgPause from '../../SVG/Pause';
import SvgDownload from '../../SVG/Download';
import description from '../../Settings/sets/ObjectObject/items/description';
import moment from 'moment';
import 'moment/locale/ru';
import { buildGETUrl } from '../../../utilities/buildGETUrl';
import { downloadVideos } from '../../../store/ContentVideolists/actions';
import { download } from '../../../utilities/download';
import { baseURL } from '../../../sagas/root';

moment.locale('ru');
const secondsToTimeFormat = (totalSeconds) => {
    if (totalSeconds === 0 || isNaN(totalSeconds)) return '00:00';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Форматируем с ведущими нулями
    const pad = (num) => num.toString().padStart(2, '0');

    if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else {
        return `${pad(minutes)}:${pad(seconds)}`;
    }
};

const HistoryTrack = ({
    className = "",
    variant,
    clipEnded,
    clipDeleted,
    trackIsNew,
    trackWarning,
    isPlaying,
    disabled,
    color,
    id,
    name,
    ctime,
    mimetype,
    isSelected,
    isMarkItems,
    cliptime = "00:00:00",
    pri,
    filename,
    play,
    pause,
    rewind,
    openModal,
    audio,
    text,
    description: textDescription,
    first
}) => {
    filename = buildGETUrl("clip/play", { id })
    const currentTime = audio?.current ? secondsToTimeFormat(audio?.current.currentTime) : "0:00"
    const [state, setState] = useState({
        played: false,
        listLoaded: false,
        opened: false
    });
    const [slider, setSlider] = useState(0);

    const [currentWatcherInterval, setCurrentWatcherInterval] = useState(null);

    const downloadVideo = () => {

        download(`${baseURL}/clip/download.php?id=${id}&token=${window.localStorage.getItem("sessionToken")}`)

    };

    useEffect(() => {
        if (isPlaying) {
            startWatch();
        } else {
            killWatcher();
        }

        return () => killWatcher();
    }, [isPlaying, audio]);


    function startWatch() {
        killWatcher(); // Сначала очищаем предыдущий интервал

        if (isPlaying && audio) {
            const interval = setInterval(() => {
                if (isPlaying) {
                    updateTime();
                }
            }, 50);
            setCurrentWatcherInterval(interval);
        }
    }

    function killWatcher(resetTime) {
        if (currentWatcherInterval) {
            clearInterval(currentWatcherInterval);
            setCurrentWatcherInterval(null);
        }
        updateTime(resetTime);
    }


    const updateTime = (resetTime) => {
        let currentTime = "00:00"


        if (resetTime !== true && (audio?.current?.currentTime !== audio?.current?.duration && isPlaying)) {
            // Время
            currentTime = formatSecondsToTime(audio.current?.currentTime)

            // Слайдер

            const sliderPercent = (audio.current?.currentTime / (audio.current?.duration / 100))
            setSlider(sliderPercent)
        }

    }

    const rewinds = (e) => {
        const rect = e.target.getBoundingClientRect()
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width)
        const totime = clickPercent * 0.01
        console.log({ totime, audio });
        audio.current.currentTime = audio.current.duration * totime


    }



    const handlePlay = () => {
        console.log('HistoryTrack handlePlay:', { id, filename, name, cliptime, mimetype });
        let duration;

        if (cliptime) {
            duration = cliptime.split(":").splice(1).join(":");
        }


        const isAudio = mimetype && (mimetype.indexOf("mp3") !== -1 || mimetype.indexOf("audio") !== -1);
        const isVideo = mimetype && (mimetype.indexOf("mp4") !== -1 || mimetype.indexOf("video") !== -1);

        if (isAudio) {
            console.log('Playing audio:', { trackId: id, filename, name, duration });
            play({
                trackId: id,
                filename,
                name,
                duration
            });
        } else if (isVideo) {
            pause();
            openModal({
                type: "video",
                data: {
                    video: {
                        title: name,
                        mp4: filename,
                    }
                }
            });
        }
    };

    const handlePause = () => {
        pause();
    };

    const handleRewind = (e) => {
        const rect = e.target.getBoundingClientRect();
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width);
        const totime = (clickPercent * 0.01);
        const timeInSeconds = audio?.current?.duration ? audio.current.duration * totime : totime;
        rewind(timeInSeconds);
    };

    const toggleOpen = () => {
        setState(prev => ({
            ...prev,
            listLoaded: true,
            opened: !prev.opened
        }));
    };

    const cliptimeArr = cliptime.split(":");
    const formattedCliptime = `${cliptimeArr[1]}:${cliptimeArr[2]}`;
    const isAudio = (mimetype.indexOf("mp3") !== -1 || mimetype.indexOf("audio") !== -1);

    const combinedClassName = cl(
        className,
        { "Track": [variant] },
        { "selectable-item": ["m-top"] },
        { "opened": state.opened },
        { "playing": isPlaying },
        { "selected": isSelected },
        { "highlighted": isMarkItems },
        { "disabled": disabled },
        { "warning": trackWarning },
        { "clip-ended": clipEnded },
        { "clip-deleted": clipDeleted },
        { "track-is-new": !!trackIsNew },
        { "name-fade": slider === 100 },
        { "current": first }
    );

    return (
        <section className={combinedClassName} title={`${name}. ${text ? "Текст рекламы - " + text + ". " : ""}${textDescription ? " Описание - " + textDescription : ""}`}>
            <header className="Track__header" >
                <span className="rewind" onClick={rewinds}></span>

                <span className={cl("slider-1", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>
                <span className={cl("slider-2", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>

                <div className="Tracks__grid">

                    <div className="play" >
                        <span onClick={downloadVideo}>
                            <SvgDownload className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                        </span>
                    </div>

                    <div className="play">
                        <span onClick={handlePlay}>
                            {isAudio
                                ? <SvgPlay className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                                : <SvgPlayVideo className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                            }
                        </span>
                        <span onClick={handlePause}>
                            <SvgPause className="icon-pause" variant="prim" size="xs1" title="Приостановить" />
                        </span>
                    </div>
                    <div style={{ display: isPlaying ? 'none' : 'flex', flexDirection: 'column' }}>
                        <div className="id">{id}</div>
                        <div className="ctime" title={moment(ctime).format("mm:hh")}>
                            от {moment(ctime).format("DD.MM.YY")}
                        </div>
                    </div>
                    <div className="time">
                        <span className="from">{currentTime}</span>
                        <span className="to">{formattedCliptime.slice(0, 5)}</span>
                    </div>


                    <div className="name" data-track-id={id}>
                        <h4 data-track-id={id} className="ellipsis desktop selectable-item__color" style={{ color }}>
                            {name.length > 40 ? `${name.slice(0, 38)}…` : name}
                        </h4>
                    </div>

                </div>
            </header>
        </section>
    );
};

HistoryTrack.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(["gray"]),
    track: PropTypes.exact({
        id: PropTypes.number,
        name: PropTypes.string,
        src: PropTypes.string,
    }),
    trackWarning: PropTypes.bool,
    clipEnded: PropTypes.bool,
    clipDeleted: PropTypes.bool,
    disabled: PropTypes.bool,
    trackPri: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
    isMarkItems: state.marks[state.marks.current].items.includes(props.id),
    isPlaying: state.audio.currentTrack?.trackId === props.id && state.audio.isPlaying,
    audio: state.audio.audio
});

const mapDispatchToProps = {
    openModal,
    play: playTrack,
    pause: pauseTrack,
    stop: stopTrack,
    rewind: seekTrack,
    downloadVideos
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTrack);